var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperflow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 47,
    viewBox: "0 0 148 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_33562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9112 23.2172C41.9112 36.0398 32.7223 46.4344 21.3873 46.4344C10.0522 46.4344 0.863281 36.0398 0.863281 23.2172C0.863281 10.3947 10.0522 0 21.3873 0C32.7223 0 41.9112 10.3947 41.9112 23.2172Z",
    fill: "url(#paint0_linear_164_33562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6057 10.4942L28.1371 10.0997M14.1072 14.7824L24.0296 14.4108M10 19.0934L19.6178 18.7332M16.2445 23.0138L29.5164 22.5168M22.7954 26.9286L32.7177 26.557M14.7288 31.3879L27.6961 30.9023M18.5382 35.4054L24.8065 35.1705",
    stroke: "white",
    strokeWidth: 0.551409,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5854 30.5482C57.2006 30.5482 59.5711 28.8786 59.5711 26.2633C59.5711 23.118 56.5274 22.6462 54.0401 22.2714C52.0636 21.9762 50.2646 21.6811 50.2646 20.0309C50.2646 18.6737 51.4705 17.7107 53.4664 17.7107C55.5403 17.7107 56.8846 18.7921 56.8846 20.5802H59.1749C59.1554 17.7495 56.8846 15.8623 53.3668 15.8623C49.9486 15.8623 47.7557 17.5922 47.7557 20.1882C47.7557 23.3916 50.8967 23.7858 53.3668 24.1391C55.3043 24.4343 57.0815 24.7101 57.0815 26.4011C57.0815 27.7972 55.7373 28.702 53.6829 28.702C51.3708 28.702 49.9486 27.5408 49.9486 25.6536L47.5977 25.673C47.5977 28.6029 49.9681 30.5482 53.5854 30.5482Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.498 30.4903C66.9397 30.4903 68.0654 29.7621 68.7776 28.4652H68.9357V30.1757H71.187V20.1884H68.9357V25.9102C68.9357 27.4635 67.7883 28.5837 66.3466 28.5837C64.8659 28.5837 63.9371 27.4419 63.9371 25.8305V20.1884H61.6836V26.2032C61.6836 28.6806 63.2054 30.4903 65.498 30.4903Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.791 34.6975H76.0251V28.3466H76.2026C76.8931 29.6844 78.1574 30.4901 79.8567 30.4901C82.6623 30.4901 84.6388 28.3466 84.6388 25.182C84.6388 21.9957 82.6818 19.8738 79.8567 19.8738C78.1379 19.8738 76.8931 20.6795 76.2026 22.0173H76.0251V20.1883H73.791V34.6975ZM79.1662 28.5836C77.3088 28.5836 75.945 27.1488 75.945 25.182C75.945 23.2151 77.3088 21.7803 79.1662 21.7803C81.0431 21.7803 82.3852 23.2151 82.3852 25.182C82.3852 27.1488 81.0431 28.5836 79.1662 28.5836Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5702 30.4901C93.9795 30.4901 96.0747 29.1933 96.6271 27.2652L94.6528 26.9507C94.2371 28.0709 93.0313 28.8787 91.6697 28.8787C89.8123 28.8787 88.4875 27.64 88.3294 25.7916H96.9435L96.9624 25.182C96.9624 22.0172 94.7914 19.8738 91.5896 19.8738C88.3294 19.8738 86.0391 21.9957 86.0391 25.1626C86.0391 28.3466 88.3099 30.4901 91.5702 30.4901ZM88.3099 24.4926C88.4875 22.7045 89.7517 21.4658 91.5506 21.4658C93.289 21.4658 94.5727 22.7627 94.6918 24.4926H88.3099Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.957 30.1755H101.191V24.9255C101.191 23.1181 102.119 21.9181 103.543 21.9181C104.036 21.9181 104.648 22.056 105.2 22.3317V20.2658C104.806 20.0891 104.333 19.9922 103.878 19.9922C102.672 19.9922 101.823 20.6794 101.349 21.8191H101.191V20.1883H98.957V30.1755Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.768 30.1744H110V21.8372H112.428V20.1871H110V18.6144C110 17.6902 110.571 17.2571 111.383 17.2571C111.719 17.2571 112.231 17.3153 112.548 17.4145V15.6048C112.015 15.4475 111.303 15.3506 110.691 15.3506C108.952 15.3506 107.768 16.5484 107.768 18.6144V20.1871H106.227V21.8372H107.768V30.1744Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.283 30.1761H116.536V15.667H114.283V30.1761Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.965 30.4904C127.225 30.4904 129.437 28.3856 129.437 25.1822C129.437 21.9766 127.225 19.874 123.965 19.874C120.704 19.874 118.512 21.9572 118.512 25.1822C118.512 28.3856 120.726 30.4904 123.965 30.4904ZM123.965 28.5839C122.087 28.5839 120.746 27.1685 120.746 25.1822C120.746 23.196 122.087 21.7806 123.965 21.7806C125.861 21.7806 127.205 23.196 127.205 25.1822C127.205 27.1685 125.861 28.5839 123.965 28.5839Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.643 30.1757H136.546L138.7 22.7821H138.858L141.031 30.1757H143.934L147.078 20.1884H144.824L142.454 27.9547H142.315L139.864 20.1884H137.672L135.34 27.8943H135.182L132.832 20.1884H130.502L133.643 30.1757Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.145108
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_33562",
    x1: 45.7173,
    y1: 48.8036,
    x2: 31.5528,
    y2: -12.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3451B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB45FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_33562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.849,
    height: 46.4344,
    fill: "white",
    transform: "translate(0.863281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperflow);
export default __webpack_public_path__ + "static/media/superflow.91f67d954e702f4f1dd67ccde5e89d95.svg";
export { ForwardRef as ReactComponent };